import templateUrl from './breadcrumbs.html'

/**
 * Component for page breadcrumbs.
 *
 * @example
 *   <tmr-breadcrumbs breadcrumbs="[
 *     { translate: 'ADMIN.ANTENNAS.TITLE', sref: '^.^' },
 *     { title: $ctrl.resource.description },
 *     { translate: 'ADMIN.ANTENNAS.TEST.TITLE', translate-values: { myVar: 'myValue' }}
 *   ]"></tmr-breadcrumbs>
 *
 * @type {ngComponent}
 * @prop {array} breadcrumbs
 * @prop {string=} breadcrumbs.title The translated title, if available
 * @prop {string=} breadcrumbs.translate The localization key for the title
 * @prop {object=} breadcrumbs.translateValues Variables for the localization string
 * @prop {string=} breadcrumbs.sref The state that the link points to
 */
export const tmrBreadcrumbs = {
  ngType: 'component',
  templateUrl,
  bindings: {
    breadcrumbs: '<',
  },
}
